import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class RolesTableController implements angular.IComponentController {
    readonly isLoading: boolean;
    readonly roles;// TYpe to be determined

    static $inject = [];
}

export const wtRolesTable: ComponentDefinition = {
    componentId: 'wtRolesTable',
    controller: RolesTableController,
    template: require('./rolesTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        roles: '<',
        isLoading: '<?'

    }
};
